module.exports = __webpack_public_path__ + "img/kbeauty-4.6590a722.svg";